export const navigationItems = [
  { id: 'quick-nav', label: '快速导航', href: '#quick-nav' },
  { id: 'scenarios', label: '实践场景', href: '#scenarios' },
  { id: 'collaboration', label: '协作方法', href: '#collaboration' },
  { id: 'ai-basics', label: 'AI能力分类', href: '#ai-basics' },
  { id: 'ai-tools', label: 'AI工具详解', href: '#ai-tools' },
  { id: 'growth', label: '个人成长', href: '#growth' },
];